import React, { useEffect, useState } from 'react';
import classes from './HomePage.module.css';
import Layout from '../component/Layout';
import SubLayout from '../component/SubLayout';
import Header from '../component/Header';
import Container from '../component/Container';
import { upcomingMatchesApi, userMatchesApi } from '../http/http';
import { useDispatch, useSelector } from 'react-redux';
import moment from 'moment-timezone';
import { useNavigate } from 'react-router-dom';
import BottomNavbar from '../component/BottomNavbar';
import { FaCircle, FaMinus } from 'react-icons/fa6';
import MatchLayout from '../component/MatchLayouts/MatchLayout';
import MatchLayout2 from '../component/MatchLayouts/MatchLayout2';
import MatchLayoutForPrediction from '../component/MatchLayouts/MatchLayoutForPrediction';
import { toast } from 'react-toastify';
import SmallLoader from '../component/SmallLoader';
import { removeUserDetails } from '../store/slices/userSlice';

const HomePage = () => {
    const [upcomingMatches, setUpcomingMatches] = useState([]);
    const [userMatches, setUserMatches] = useState(null);
    const { userDetails } = useSelector(state => state.persisted?.userSlice);
    const navigate = useNavigate();
    const [userMatchesLoading, setUserMatchesLoading] = useState(true);
    const [loading, setLoading] = useState(true);

    const [loader, setLoader] = useState(true);
    const dispatch = useDispatch();

    const fetchUserMatches = async (load) => {
        try {
            if (load) {
                setUserMatchesLoading(true);
            }
            setLoader(true);
            const response = await userMatchesApi(userDetails?.token);
            console.log(response, 'response...');
            setUserMatches({
                fantasy: response?.data?.fantasy,
                prediction: response?.data?.prediction
            });

            setUserMatchesLoading(false);
            setLoader(false);
        } catch (error) {
            setUserMatchesLoading(false);
            setLoader(false);

            toast.error(error?.response?.data?.message || error?.response?.message || error?.data?.message || "Something Went Wrong!");
            console.log(error, 'error---');
        }
    }

    const fetchUpcomingMatches = async (load) => {
        try {
            if (load) {
                setLoading(true);
            }
            setLoader(true);
            const response = await upcomingMatchesApi(userDetails?.token);
            setUpcomingMatches(response?.data);
            console.log(response, 'response...');
            setLoading(false);
            setLoader(false);


        }
        catch (error) {
            if (error?.response?.status == 403) {
                dispatch(removeUserDetails());
                toast.error("Login Again!");
                navigate('/');
            }
            else {
                setLoading(false);
                setLoader(false);
                toast.error(error?.response?.data?.message || error?.response?.message || error?.data?.message || "Something Went Wrong!");
            }

        }
    }

    useEffect(() => {
        fetchUserMatches(true);
        fetchUpcomingMatches(true);
    }, []);

    useEffect(() => {
        if (!loader) {
            const intervalId = setInterval(() => {
                if (!document.hidden) {
                    fetchUserMatches();
                    fetchUpcomingMatches();
                }
            }, 10000);
            return () => clearInterval(intervalId);
        }

    }, [loader]);

    return (
        <Layout>
            <SubLayout>
                <Header active={0} />
                {(loading || userMatchesLoading) ?
                    <SmallLoader /> : (
                        <>
                            <Container>
                                <div className={classes.upcoming_matches_container}>
                                    {upcomingMatches.length > 0 &&
                                        upcomingMatches.map((match, index) => {
                                            return (
                                                <MatchLayout match={match} key={index} fantasy_match_joined={userMatches?.fantasy?.filter(data => data?.match_fixture_id == match?.match_fixture_id).length > 0}
                                                    prediction_match_joined={userMatches?.prediction?.filter(data => data?.match_fixture_id == match?.match_fixture_id).length > 0}
                                                />
                                            )
                                        }
                                        )}
                                </div>
                            </Container>
                        </>
                    )
                }

            </SubLayout>
        </Layout>
    )
}

export default HomePage;